import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { WorkflowMock } from './WorkflowMock';
import { techProofPoints } from '../data/content';
import type { LandingActions } from '../types/actions';
export function TechnologySection({
  onFormCta
}: Pick<LandingActions, 'onFormCta'>) {
  return <section id="technology" className="w-full bg-white" data-id="element-171" data-mp="23vf3tv7iakp8">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-172" data-mp="176qzu2smkxyt">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-14" data-id="element-173" data-mp="178tyfb7ufzf5">
          <div data-id="element-174" data-mp="1ba5fgscnjcbq">
            <h2 className="font-display text-[26px] font-semibold leading-[1.12] tracking-[-0.025em] text-ink md:text-[38px]" data-id="element-175" data-mp="1g75lx4deyh3d">
              Technology should create more time for clients, not more work for agents.
            </h2>
            <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-ink-600 md:mt-6 md:text-[17px]" data-id="element-176" data-mp="2rn3yvjbppn9v">
              NEXT is not technology for technology's sake. The goal is simple: fewer dropped opportunities, more
              consistent follow-up, cleaner workflows, better visibility, and more time spent serving clients.
            </p>

            <ul className="mt-6 space-y-3 border-t border-line pt-6" data-id="element-177" data-mp="wv8ohzcvm54v">
              {techProofPoints.map(point => <li key={point} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-ink" data-id="element-178" data-mp="mz5n4vpumaiz">
                  <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-179" data-mp="i0m0et3fkupk" />
                  {point}
                </li>)}
            </ul>

            <div className="mt-7" data-id="element-180" data-mp="97s5xofexor4">
              <Button onClick={() => onFormCta('technology')} fullWidth className="sm:w-auto" data-id="element-181" data-mp="96z51434xtgw">
                See What NEXT Can Help You Build
              </Button>
            </div>
          </div>

          <WorkflowMock data-id="element-182" data-mp="3vf8nshijmyxt" />
        </div>
      </div>
    </section>;
}